import Vue from 'vue'

const removeCategory = (id, category) => id.replace(category, '')

// Vue.prototype.$window = Window
// const objectChangeKeyCase =

Array.prototype.last = function () {
  return this[this.length - 1]
}
Array.prototype.first = function () {
  return this[0]
}
Array.prototype.objectInsertion = function (object, localKey, foreignKey) {
  const arr = this.valueOf()
  if (!foreignKey || !localKey || !Object.keys(object).length) return arr
  const current = object[foreignKey]
  let i = arr.length - 1
  while (i > -1 && current < arr[i][localKey]) {
    arr[i + 1] = arr[i]
    i -= 1
  }
  arr[i + 1] = object
  return arr
}

Array.prototype.or = function () {
  return this.valueOf().some(condition => condition)
}

Array.prototype.and = function () {
  return this.valueOf().every(condition => condition)
}

Number.prototype.phpFormat = function () {
  return new Intl.NumberFormat('en-PH', { style: 'currency', currency: 'Php' }).format(this.valueOf())
}

Number.prototype.currencyFormat = function () {
  return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'Php', signDisplay: 'never' }).format(this.valueOf())
}

String.prototype.escapeRegExp = function () {
  return (this.valueOf()).replace(/[.*+?^${}()|[\]\\]/g, '\\$&') // $& means the whole matched string
}

String.prototype.formatMoney = function (decimalCount = 2, decimal = '.', thousands = ',') {
  decimalCount = Math.abs(decimalCount)
  decimalCount = Number.isNaN(decimalCount) ? 2 : decimalCount
  let amount = Number.isNaN(this.valueOf()) ? 0 : parseInt(this.valueOf(), 10)
  const negativeSign = amount < 0 ? '-' : ''
  const i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount), 10).toString()
  const j = (i.length > 3) ? i.length % 3 : 0
  return negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, `$1${thousands}`) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : '')
}

String.prototype.first = function () {
  return this.valueOf().substr(0, 1)
}
String.prototype.camelToSnakeCase = function (separator = '_') {
  return this.valueOf().replace(/[A-Z]/g, letter => `${separator}${letter.toLowerCase()}`)
}

String.prototype.snakeToCamelCase = function () {
  return this.valueOf().replace(/([-_][a-z])/g, group => group.toUpperCase().replace('-', '').replace('_', ''))
}
//  sv-SE yyyy-mm-dd
String.prototype.dateFormat = function (params = {}, locale = 'en-US') {
  const {
    year = 'numeric',
    month = '2-digit',
    day = '2-digit',
    hour = null,
    minute = null,
    second = null,
  } = params

  if (!this.valueOf()) return 'N/A'

  const date = new Date(this.valueOf())
  const options = { year, day, month, hour, minute, second }
  Object.keys(options).forEach(key => {
    if (!options[key]) delete options[key]
  })
  return date.toLocaleString(locale, options)
}

Number.prototype.unitFormat = function (unit = 'kg') {
  const number = this.valueOf()
  return new Intl.NumberFormat('en-US', { style: 'unit', unit }).format(number)
}

String.prototype.dateFormat_ENUS = function () {
  const date = new Date(this.valueOf())
  return date.toLocaleString('en-US', {
    day: 'numeric', // numeric, 2-digit
    year: 'numeric', // numeric, 2-digit
    month: 'long', // numeric, 2-digit, long, short, narrow
    hour: 'numeric', // numeric, 2-digit
    minute: 'numeric', // numeric, 2-digit
  })
}

String.prototype.addDays = function (days) {
  const date = this.valueOf() || null
  const regex = /^[0-9]{4}-[0-9]{2}-[0-9]{2}$/i
  if (!date || !regex.test(date)) return
  const result = new Date(date)
  result.setDate(result.getDate() + days)
  return result.toLocaleString('sv-SE', { year: 'numeric', month: '2-digit', day: '2-digit' })
}

Vue.prototype.$objectFilterKeys = function (object = {}, keys = []) {
  return Object.keys(object)
    .filter(key => !keys.includes(key))
    .reduce((result, key) => {
      result[key] = object[key]
      return result
    }, {})
}
Vue.prototype.$alertSwalLoading = function (text = 'Loading...') {
  return this.$swal('loading', {
    config: {
      loading: {
        text,
      },
    },
  })
}

Vue.prototype.$alertSwalSuccess = function (text = 'Success') {
  const config = {
    title: {
      text,
    },
  }
  this.$swal('success', { config })
}

Vue.prototype.$alertSwalError = function (text = 'error...') {
  const config = {
    title: {
      text,
    },
  }
  this.$swal('error', { config })
}

Vue.prototype.$objectAttributesToNumeric = function (object = {}, attributes = []) {
  return Object.keys(object).reduce((result, key) => {
    if (attributes.includes[key] || isNaN(object[key])) {
      result[key] = object[key]
      return result
    }
    result[key] = Number(object[key])
    return result
  }, {})
}

Vue.prototype.$intToInvoiceNumber = function (invoice = 0) {
  if (!invoice) return null
  return `DR${invoice.toString().padStart(6, '0')}`
}

Vue.prototype.$getCurrentDate = function () {
  const date = new Date()
  const attributes = [
    date.getFullYear().toString(),
    (date.getMonth() + 1).toString().padStart(2, '0'),
    date.getDate().toString().padStart(2, '0'),
  ]
  return attributes.join('-')
}

Vue.prototype.$getCurrentDate_enUS = function () {
  const date = new Date()
  return date.toLocaleString('en-US', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  })
}

Vue.prototype.$float = function (val = '0') {
  return parseFloat(val)
}

Vue.prototype.$genKeyIdCategory = function (id = '0', category = '', stringLength = 4) {
  if (!category) return
  const ID_NUM = (removeCategory(id, category).extractFirstInt() + 1).toString().padStart(stringLength, '0')
  return `${category}${ID_NUM}`
}

Vue.prototype.$objectEmpty = function (object) {
  if (typeof object !== 'object' || Array.isArray(object)) return false
  return !Object.keys(object).length
}

Vue.prototype.$objectChangeKeyCase = function (data = {}, caseFormat = 'snakeToCamelCase') {
  const result = {}
  if (!['snakeToCamelCase', 'camelToSnakeCase'].includes(caseFormat)) return {}
  Object.keys(data).forEach(key => {
    const key2 = key.toString()[caseFormat]()
    result[key2] = data[key]
  })
  return result
}

Vue.prototype.$autoAbbriviate = function (string) {
  if (!string) return
  const result = string.match(/(?<=\()[A-Za-z0-9'\(\)]{1,}(?=[\)])/g)
  return !result ? string : result.first()
}

String.prototype.extractFirstInt = function () {
  return parseInt(this.valueOf().match(/[0-9]+/i)[0], 10)
}

String.prototype.extractFirstString = function () {
  return this.valueOf().match(/[a-zA-Z]+/i)[0]
}

String.prototype.toInt = function () {
  return parseInt(this.valueOf(), 10)
}

Window.objectChangeKeyCase = function (data = {}, caseFormat = 'snakeToCamelCase') {
  const result = {}
  if (!['snakeToCamelCase', 'camelToSnakeCase'].includes(caseFormat)) return {}
  Object.keys(data).forEach(key => {
    const key2 = key.toString()[caseFormat]()
    result[key2] = data[key]
    if (data[key] && typeof data[key] === 'object' && !Array.isArray(data[key])) {
      result[key2] = Window.objectChangeKeyCase(data[key], caseFormat)
    }
  })
  return result
}

Window.objectFilterKeys = function (object = {}, keys = []) {
  return Object.keys(object)
    .filter(key => !keys.includes(key))
    .reduce((result, key) => {
      result[key] = object[key]
      return result
    }, {})
}

const parseDate = function (date) {
  if (!date) return new Date()
  return new Date(date)
}

Window.currentDate = function () {
  return new Date().toLocaleString('sv-SE', { year: 'numeric', month: '2-digit', day: '2-digit' })
}

Window.getDateMysql = function (date = null, format = 'sv-SE') {
  return parseDate(date).toLocaleString(format, { year: 'numeric', month: '2-digit', day: '2-digit' })
}

Window.objectEmpty = function (object) {
  if (typeof object !== 'object' || Array.isArray(object)) return false
  return !Object.keys(object).length
}

Window.generateRandomNumber = function (limit = 100, start = 0) {
  return Math.floor(Math.random() * limit) + start
}

Window.downloadExcel = function (data, name) {
  const blob = new Blob([data], { type: 'application/xlsx' })
  const link = document.createElement('a')
  link.href = URL.createObjectURL(blob)
  link.download = `${name}_${new Date().getTime()}.xlsx`
  link.click()
  URL.revokeObjectURL(link.href)
}
